/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import { EventEmitter } from 'events';

import * as React from 'react';
import { useState } from 'react';

import {
  ApolloClient,
  ApolloProvider,
  createHttpLink,
  InMemoryCache,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { Box } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { GRAPHQL_SERVICE } from 'api/service_urls';
import { FeatureFlagsProvider } from 'app/flagsmith';
import { AppProvider } from 'app/providers/AppProvider';
import { Authentication } from 'containers/Authentication';
import { TaskToastComponent } from 'containers/CustomerJourney/TaskToastComponent';
import { BusContext } from 'hooks/useBus';

import Main from './containers/App';

import 'react-sortable-tree/style.css';
import 'focus-visible/dist/focus-visible';
import 'react-day-picker/dist/style.css';
import 'react-day-picker/style.css';
// const TRACKING_ID = 'G-7VGG00X5XR'; // OUR_TRACKING_ID
// ReactGA.initialize(TRACKING_ID, { debug: true });
// ReactGA.set({ domain: 'none' });

const queryCache = new QueryClient();

const authLink = setContext((_, { headers }) => {
  // get the authentication token from session storage
  const token = sessionStorage.getItem('authentication');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});
export const graphqlLink = createHttpLink({
  uri: GRAPHQL_SERVICE,
});
const graphqlClient = new ApolloClient({
  link: authLink.concat(graphqlLink),
  cache: new InMemoryCache(),
});

function App() {
  const [bus] = useState(new EventEmitter());

  return (
    <BusContext.Provider value={bus}>
      <FeatureFlagsProvider>
        <BrowserRouter>
          <Helmet titleTemplate="%s - ARIKSA" defaultTitle="ARIKSA">
            <meta name="description" content="ARIKSA" />
            <style>@import url(font.css);</style>
          </Helmet>
          <AppProvider>
            <QueryClientProvider client={queryCache}>
              <ApolloProvider client={graphqlClient}>
                <Routes>
                  <Route path={'/auth/*'} element={<Authentication />} />
                  <Route path="*" element={<Main />} />
                </Routes>
                {/*<RoleAccessReport />*/}
                {/*<UserAccessReports />*/}
                <TaskToastComponent />
                <Box className={'portal-container'} />
              </ApolloProvider>
            </QueryClientProvider>
          </AppProvider>
        </BrowserRouter>
      </FeatureFlagsProvider>
    </BusContext.Provider>
  );
}

export default Sentry.withProfiler(App, { name: 'WebApp' });
